<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <el-select
      v-model="ratioOptVal"
      placeholder="请选择"
      size="small"
      style="width:120px;"
      @change="onRatioOptValChanged"
    >
      <el-option
        v-for="(ratioOpt, index) in ratioOpts"
        :key="index"
        :label="ratioOpt.label"
        :value="ratioOpt.value">
      </el-option>
    </el-select>

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <div v-if="ratioOptVal === 'CUSTOM'" class="ratio-factors-select-group">
          <div style="display:flex;gap:10px;align-items:center;">
            <label style="font-size:.875em;color:#606266;">选择分子:</label>
            <el-cascader
              v-model="id1"
              placeholder="选择分子"
              size="small"
              style="width:120px;height:32px;"
              :options="factorTree.length === 1 ? factorTree[0].children : factorTree"
              :show-all-levels="false"
              :props="{
                emitPath: false,
                expandTrigger: 'hover',
                value: 'id',
                label: 'name'
              }"
              @change="onCustomFactorIdChanged"
            />
          </div>

          <div style="display:flex;gap:10px;align-items:center;">
            <label style="font-size:.875em;color:#606266;">选择分母:</label>
            <el-cascader
              v-model="id2"
              placeholder="选择分母"
              size="small"
              style="width:120px;height:32px;"
              :options="factorTree.length === 1 ? factorTree[0].children : factorTree"
              :show-all-levels="false"
              :props="{
                emitPath: false,
                expandTrigger: 'hover',
                value: 'id',
                label: 'name'
              }"
              @change="onCustomFactorIdChanged"
            />
          </div>
        </div>

        <el-input
          type="number"
          v-model="ratioLow"
          size="small"
          style="width:160px;"
          @change="onRatioLowChanged"
        >
          <template slot="prepend">异常比值 &lt;</template>
        </el-input>
      </template>

      <ratio-chart
        v-for="data in dataList"
        v-if="data.dimensions.length === 2"
        :key="data.id"
        :data-config="data"
        :ratio-low="currentRatioLow"
        :unit-prop="unitProp"
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import DeviceCategoryConfig from '../../../../../model/DeviceCategoryConfig'
import {mapGetters} from 'vuex'

import LayoutContent from '../../../../../components/Layout/Content'
import DataTimeQuery from '../../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import RatioChart from './RatioChart'
import YaoBaseSiteFactorData from '../../../../YaoBaseSiteFactorData'

export default {
  name: 'StatisticalAnalysisVOCsSpeciesRatio',
  routeInfo: {
    label: 'VOCs物种比值',
    icon: 'fa fa-eye'
  },
  extends: YaoBaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, RatioChart},
  data: () => ({
    query: {
      isFuse: false,
      isMultipleIntegral: true
    },
    unitProp: 'stdUnit',
    ratioOptVal: null,
    id1: null,
    id2: null,
    ratioLow: null,
    currentRatioLow: null
  }),
  computed: {
    ...mapGetters({
      specificFactors: 'Factor/specificFactors'
    }),
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true)
    ],
    isSetAllFactorIds: () => false,
    ratioOpts () {
      let {filterFactorMap} = this
      let ratioOpts = this.specificFactors.reduce((list, specificFactor) => {
        let {factorId} = specificFactor
        let factor = filterFactorMap[factorId]

        if (factor) {
          let {specificValueFactorId} = specificFactor
          let specificValueFactor = filterFactorMap[specificValueFactorId]

          if (specificValueFactor) {
            list.push({
              value: `${factorId}-${specificValueFactorId}`,
              label: `${factor.name}/${specificValueFactor.name}`,
              id1: factorId,
              id2: specificValueFactorId,
              ratioLow: specificFactor.specificValueLow
            })
          }
        }
        return list
      }, [])

      ratioOpts.push({
        value: 'CUSTOM',
        label: '任意因子',
        ratioLow: 1
      })

      return ratioOpts
    },
    currentRatioOpt () {
      let {ratioOptVal} = this
      return this.ratioOpts.find(ratioOpt => ratioOpt.value === ratioOptVal)
    },
    isNoSelectedFactors () {
      return this.query.factorIds.length < 2
    }
  },
  methods: {
    // onAuditCompletedChanged () {
    //   let {query} = this
    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }
    //   query.isMultipleIntegral = false
    //   this.afterSetSiteIds()
    // },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    setOther () {
      let {query} = this

      if (!this.ratioOptVal) {
        let [firstRatioOpt] = this.ratioOpts
        this.ratioOptVal = firstRatioOpt.value
        this.ratioLow = this.currentRatioLow = firstRatioOpt.ratioLow
      }

      this.setRatioFactorIds()

      return query.factorIds.length === 2
    },
    setRatioFactorIds () {
      let {ratioOptVal, query} = this

      let id1, id2
      if (ratioOptVal === 'CUSTOM') {
        id1 = this.id1
        if (!id1) {
          query.factorIds = Object.freeze([])
          return
        }

        id2 = this.id2
        if (!id2) {
          query.factorIds = Object.freeze([])
          return
        }
      } else {
        let {currentRatioOpt} = this
        id1 = currentRatioOpt.id1
        id2 = currentRatioOpt.id2
      }

      query.factorIds = Object.freeze([id1, id2])
    },
    onRatioOptValChanged () {
      this.ratioLow = this.currentRatioLow = this.currentRatioOpt.ratioLow
      this.afterSetSiteIds()
    },
    onCustomFactorIdChanged () {
      this.afterSetSiteIds()
    },
    onRatioLowChanged () {
      this.currentRatioLow = Number(this.ratioLow)
    }
  }
}
</script>

<style lang="scss" scoped>
.ratio-factors-select-group {
  display: flex;
  gap: 20px;
  align-items: center;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/02Species-Ratio/index.vue